import { AddSourcesContent } from "@mirage/mosaics/Chat/components/compose-sources/AddSourcesContent";
import { useIsMobileSizeForSidebar } from "@mirage/shared/responsive/mobile";
import i18n from "@mirage/translations";
import classnames from "classnames";
import { memo } from "react";
import styles from "./SourcesFromSettingsOne.module.css";

import type { PAPEvent } from "@mirage/analytics/events/base/event";
import type { ActionSurfaceComponent } from "@mirage/analytics/events/enums/action_surface_component";
import type { SourcesContentCache } from "@mirage/mosaics/Chat/data/ComposeSourcesCache";
import type { ChatSource } from "@mirage/mosaics/Chat/types";
import type { RenderFooterSettings } from "./SourcesFromSettingsModalStepper";

interface SourcesFromSettingsOneProps {
  title?: string;
  description?: string;
  sources: ChatSource[];
  handleAddSource: (source: ChatSource) => void;
  handleRemoveSource: (source: ChatSource) => void;
  sourcesContents: SourcesContentCache;
  logComposeEvent: (
    event: PAPEvent,
    overrides?: {
      actionSurfaceComponent?: ActionSurfaceComponent;
    },
  ) => void;
  renderFooter?: (footerSettings: RenderFooterSettings) => JSX.Element; // renderFooter is derived from SourcesFromSettingsModalStepper
}
export const SourcesFromSettingsOne = memo(
  ({
    title,
    description,
    sources,
    handleAddSource,
    handleRemoveSource,
    sourcesContents,
    logComposeEvent,
    renderFooter,
  }: SourcesFromSettingsOneProps) => {
    const isMobile = useIsMobileSizeForSidebar();
    return (
      <>
        <div
          className={classnames(
            styles.SourcesFromSettingsOneContent,
            isMobile && styles.SourcesFromSettingsOneMobile,
          )}
        >
          <AddSourcesContent
            sources={sources || []}
            sourcesContentCache={sourcesContents}
            addSource={handleAddSource}
            removeSource={handleRemoveSource}
            logComposeEvent={logComposeEvent}
            onRequestClose={() => {}}
            customSnackbarMessage={i18n.t(
              "compose_assistant_file_uploader_snackbar_message_templates",
            )}
            showTitle={true}
            description={description}
            title={title}
          />
        </div>
        {renderFooter?.({ sourceCount: sources.length })}
      </>
    );
  },
);
SourcesFromSettingsOne.displayName = "SourcesFromSettingsOne";
